<template>
  <div class="container">
    <LivePlayer ref="player" :videoUrl="videoUrl" :waterMark="osd"
            :hideBigPlayButton="false" :muted="muted"
            :fluent="fluent" :stretch="stretch" :autoplay="autoplay" :controls="controls" :showCameraButton="snap" :showCustomButton="custom"
            :poster="poster" :aspect="aspect" live :hideLiveText="type == 'playback'" :alt="alt" :debug="debug"
            @media_info="onMediaInfo" @ended="onEnded" @error="onError" @message="$message" @fullscreen="onFullscreenChange"
            v-loading="bLoading" :loading.sync="bLoading" element-loading-text="加载中..." element-loading-background="#000"
            :style="aspect == 'fullscreen' ? 'width: 100% !important;height: 100% !important;position: fixed !important;':''">
            <div class="ptz-block" v-show="showPtzPanel">
              <div class="ptz-cell ptz-up" @mousedown.prevent="ptzControl('up', $event)" title="上">
                <i class="fa fa-chevron-up"></i>
              </div>
              <div class="ptz-cell ptz-left" @mousedown.prevent="ptzControl('left', $event)" title="左">
                <i class="fa fa-chevron-left"></i>
              </div>
              <div class="ptz-cell ptz-center" title="云台控制">
                <i class="fa fa-arrows"></i>
              </div>
              <div class="ptz-cell ptz-right" @mousedown.prevent="ptzControl('right', $event)" title="右">
                <i class="fa fa-chevron-right"></i>
              </div>
              <div class="ptz-cell ptz-down" @mousedown.prevent="ptzControl('down', $event)" title="下">
                <i class="fa fa-chevron-down"></i>
              </div>
              <div class="ptz-cell ptz-plus" @mousedown.prevent="ptzControl('zoomin', $event)" title="放大">
                <i class="fa fa-plus-circle"></i>
              </div>
              <div class="ptz-cell ptz-talk" @mousedown.prevent="talkStart" v-if="showTalk">
                <i class="fa fa-microphone"></i>
              </div>
              <div class="ptz-cell ptz-minus" @mousedown.prevent="ptzControl('zoomout', $event)" title="缩小">
                <i class="fa fa-minus-circle"></i>
              </div>
            </div>
          </LivePlayer>
  </div>
</template>

<script>
import LivePlayer from "@liveqing/liveplayer"
export default {
  name: 'FlvVideo',
  components: {
    LivePlayer
  },
  props: ['videoUrl'],
  data() {
    return {
    }
  },
  methods: {
    play() {
        console.log('播放视频')
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
}

.video {
  height: 100%;
  width: 100%;
}
#playButton {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    color: white;
    padding: 10px;
    border-radius: 50%;
    z-index: 2000;
}
</style>
